import config from "../config";
const base_url = config.base_url
export const downloadPartnerDocument = (partner_id, file_id, fileName) =>{
    return fetch(base_url + "admin/partners/download/partner/document", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `partner_id=${partner_id}&file_id=${file_id}`,
  })
  .then((res) => res.blob())
  .then((blob) => {
    console.log(blob);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  })
  .catch((err) => {
    console.log(err);
  });
}
export const downloadPartnerCouponCSV = (partner_id) =>{
  if(!partner_id) return
  return fetch(base_url + "admin/partners/coupons/data/download", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `partner_id=${partner_id}`,
  })
  .then((res) => res.blob())
  .then((blob) => {
    console.log(blob);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${partner_id}_coupons.csv`);
    document.body.appendChild(link);
    link.click();
  })
  .catch((err) => {
    console.log(err);
  });
}
export const downloadPartnerEventsCSV =(partner_id)=>{
  if(!partner_id) return
  return fetch(base_url + "admin/partners/events/partner/download", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `partner_id=${partner_id}`,
  })
  .then((res) => {
    if (res.status===200) return res.blob()
    else throw new Error('No CSV')
  })
  .then((blob) => {
    console.log(blob);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${partner_id}_coupons.csv`);
    document.body.appendChild(link);
    link.click();
  })
  .catch((err) => {
    console.log(err);
  });
}
export const downloadPartnersCSV =(partner_id)=>{
  return fetch(base_url + "admin/partners/data/download", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  })
  .then((res) => {
    if (res.status===200) return res.blob()
    else throw new Error('No CSV')
  })
  .then((blob) => {
    console.log(blob);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `OSTREON_Partners.csv`);
    document.body.appendChild(link);
    link.click();
  })
  .catch((err) => {
    console.log(err);
  });
}
export const downloadReferralsCSV =(partner_id)=>{
  return fetch(base_url + "admin/partners/referrals/data/download", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, /",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
  })
  .then((res) => {
    if (res.status===200) return res.blob()
    else throw new Error('No CSV')
  })
  .then((blob) => {
    console.log(blob);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `OSTREON_Referrals.csv`);
    document.body.appendChild(link);
    link.click();
  })
  .catch((err) => {
    console.log(err);
  });
}